import ImagesPortfolioGuideMainImageLowResWebp from '@/public/images/portfolio-guide/mainImageLowRes.webp';
import ImagesPortfolioGuidePortfolioGuideWebp from '@/public/images/portfolio-guide/portfolio-guide.webp';
import ImagesPortfolioGuideSection1ImgSvg from '@/public/images/portfolio-guide/section1-img.svg';
import ImagesPortfolioGuideSection2Icon1Svg from '@/public/images/portfolio-guide/section2-icon1.svg';
import ImagesPortfolioGuideSection2Icon2Svg from '@/public/images/portfolio-guide/section2-icon2.svg';
import ImagesPortfolioGuideSection2Icon3Svg from '@/public/images/portfolio-guide/section2-icon3.svg';
import ImagesPortfolioGuideSection3ImgSvg from '@/public/images/portfolio-guide/section3-img.svg';
import ImagesPortfolioGuideSection4ImgSvg from '@/public/images/portfolio-guide/section4-img.svg';
import ImagesPortfolioGuideSection5ImgSvg from '@/public/images/portfolio-guide/section5-img.svg';
import ImagesPortfolioGuideSection8ImgSvg from '@/public/images/portfolio-guide/section8-img.svg';

export {
  ImagesPortfolioGuideMainImageLowResWebp,
  ImagesPortfolioGuidePortfolioGuideWebp,
  ImagesPortfolioGuideSection1ImgSvg,
  ImagesPortfolioGuideSection2Icon1Svg,
  ImagesPortfolioGuideSection2Icon2Svg,
  ImagesPortfolioGuideSection2Icon3Svg,
  ImagesPortfolioGuideSection3ImgSvg,
  ImagesPortfolioGuideSection4ImgSvg,
  ImagesPortfolioGuideSection5ImgSvg,
  ImagesPortfolioGuideSection8ImgSvg,
};
